/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `text` - Text
 * * `number` - Number
 * * `date` - Date
 * * `select` - Dropdown - Single Select
 * * `multi-select` - Dropdown - Multiple Select
 * * `checkbox` - Checkbox
 */
export enum MetadataTemplateFieldTypeEnum {
    TEXT = 'text',
    NUMBER = 'number',
    DATE = 'date',
    SELECT = 'select',
    MULTI_SELECT = 'multi-select',
    CHECKBOX = 'checkbox',
}
